import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import WhyInvest from "@/components/landing/WhyInvest";
import Statistics from "@/components/landing/Statistics";
import CtaBanner from "@/components/landing/CtaBanner";
import Future from "@/components/landing/Future";
import Footer from "@/components/landing/Footer";
import VideoModal from "@/components/landing/VideoModal";

export default function Home() {
  const [videoOpen, setVideoOpen] = useState(false);

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-white overflow-x-hidden">
      <Navbar />
      <Hero onWatch={() => setVideoOpen(true)} onStart={() => scrollTo("#kayit")} />
      <About />
      <WhyInvest />
      <CtaBanner />
      <Statistics />
      <Future />
      <Footer />
      <VideoModal open={videoOpen} onOpenChange={setVideoOpen} />
    </main>
  );
}
